webpackJsonp([64632704166719],{

/***/ 1103:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"TextBox","methods":[],"props":{"title":{"type":{"name":"string"},"required":false,"description":"Text to show as title.","defaultValue":{"value":"''","computed":false}},"text":{"type":{"name":"string"},"required":false,"description":"Text to show as content.","defaultValue":{"value":"''","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"","defaultValue":{"value":"null","computed":false}}},"filename":"/components/TextBox/TextBox.jsx"}

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _textbox = __webpack_require__(534);
	
	var _textbox2 = _interopRequireDefault(_textbox);
	
	var _map = __webpack_require__(1103);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _textbox2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _textbox2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/TextBox',
	        description: _textbox2.default.summary,
	        stories: _textbox2.default.stories,
	        importCode: _textbox2.default.import,
	        withStyles: _textbox2.default.withStyles,
	        extractProps: _textbox2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Textbox',
	  summary: 'The <TextBox> tag defines a multi-line text input control. A TextBox can hold an unlimited number of characters, and the text renders in a fixed-width font (usually Courier). The size of a TextBox can be specified by the cols and rows attributes, or even better; through CSS height and width properties.',
	  import: '',
	  withStyles: true,
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<TextBox\n    title="Get many resources in a single request"\n    text={`GraphQL queries access not just the properties of one resource but also smoothly\n    follow references between them. While typical REST APIs require loading from multiple URLs, \n    GraphQL APIs get all the data your app needs in a single request. Apps using GraphQL can be \n    quick even on slow mobile network connections.`}\n/>',
	    tabsActive: ['code']
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-textbox-js-57d1669e818cd0d0c745.js